import { Branch } from "@/model/data/Branch";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetBranchesResData extends ApiGenericResponse {
    availableBranches: Branch[];
    deletedBranches: string[];

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Branches) {
            this.availableBranches = [];
            obj.Branches.forEach((e) => {
                let m = new Branch();
                m.parse(e);
                this.availableBranches.push(m);
            });
        }
        if (obj.DeletedBranches) {
            this.deletedBranches = [];
            obj.DeletedBranches.forEach((e) => {
                this.deletedBranches.push(e);
            });
        }
    }
}
